// TODO fix accessibility issues

/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import PropTypes from 'prop-types';

import Tooltip from 'shopper/components/Tooltip';

import Image from 'components/Image';

const Badge = ({ badgeDate, badgeImage, badgeName }) => (
  <Tooltip.Root>
    <Tooltip.Trigger>
      <Image
        alt={`Ícone da medalha ${badgeName}`}
        className={!badgeDate && 'opacity-30'}
        height={54}
        src={badgeImage}
        width={54}
      />
    </Tooltip.Trigger>
    <Tooltip.Box className="min-w-[100px]">{badgeName}</Tooltip.Box>
  </Tooltip.Root>
);

Badge.propTypes = {
  badgeDate: PropTypes.string,
  badgeId: PropTypes.number.isRequired,
  badgeImage: PropTypes.string.isRequired,
  badgeName: PropTypes.string.isRequired,
};

export default Badge;
